import type { BrandedHeadingModule } from 'types/capi/article';

import { BrandedHeadingCore } from '~/components/Content/BrandedHeading';
import type { ColumnPosition } from '~/modules/ste/ModuleRow';
import { useModuleRowContext } from '~/modules/ste/ModuleRow';

type Props = {
  columnPosition: ColumnPosition;
  module: BrandedHeadingModule;
};

export default function EmbeddedBrandedHeading({
  module,
  columnPosition
}: Props) {
  const moduleRow = useModuleRowContext();

  const xPadding =
    columnPosition === 'first'
      ? 'md:pl-4 lg:pl-0'
      : columnPosition === 'last'
        ? 'md:pr-4 lg:pr-0'
        : '';

  return (
    <div
      className={`flex w-full flex-col gap-3 py-6 max-md:gap-2.5 ${xPadding} ${
        !moduleRow?.narrow ? 'md:mx-auto md:max-w-[360px]' : ''
      }`}
    >
      <BrandedHeadingCore module={module} />
    </div>
  );
}
